<template>
  <div class="shangquanindexPage"
    @touchstart="touchEvent" 
    @touchmove="touchEvent" 
    @touchend="touchEvent" 
    @scroll="touchEvent">
      <mu-appbar class="XR-search-head">
        <mu-flat-button :label="addressCache" @click="selectArea" labelPosition="before" icon=":fa fa-angle-down" secondary  slot="left"/>             
        <div slot="default" class="search-ctrl">
         <router-link to="/shangquan/search" slot="right">           
          <mu-icon value=" " class="fa fa-xisearch" />  
          <input class="input-ctrl" placeholder="请输入关键词" />   
         </router-link>       
        </div>
        <mu-icon-button class="fa fa-fenlei1" to="/shangquan/temai" slot="right"/>
      </mu-appbar> 
      <XR-sqswiper ref="swiper" :showIndic="true">
      </XR-sqswiper>        
      <div class="nav">
        <ul>
          <li v-for="navItem in navList" :key="navItem.Fid"> 
            <div class="link-btn" @click="goToStoreList(navItem)">
              <template v-if="navItem.FiconType == 1">             
                <i :class="navItem.FiconFont"></i>
              </template>
              <template v-if="navItem.FiconType == 2">
                <img :src="navItem.FiconFont">
              </template>
              <b>{{navItem.Fname}}</b>
            </div> 
          </li>
        </ul>		
      </div>
      <div id="gonggao" style="margin-left:10px;margin-right:10px;">
        <div class="gg-title">
            <!--<img src=" ../static/shangquan/new.png" />-->
        </div>
        <div class="gg-list">
          <!--
          <img src="http://frontend.xurigo.com/icon/new.gif" class="new">
          
          <ul :class="{marquee_top:animate}">
            <template v-for="notice in noticeList">
              <router-link :to="getNoticeUrl(notice.Type,notice.Id)" :key="notice.Id">
                <li >
                  <p class="title">{{notice.Title }}</p>
                  <p class="content"><span v-html="HTMLDecode(notice.Title)"></span></p>
                </li>
              </router-link>
            </template>
          </ul>
          -->
          <ul :class="{marquee_top:animate}">
            <template v-for="notice in noticeList">
              <router-link :to="getNoticeUrl(notice.Type,notice.Id)" :key="notice.Id">
                <li>
                  <p class="title">{{notice.Title }}</p>
                  <!--<p class="content"><span v-html="HTMLDecode(notice.Title)"></span></p>-->
                </li>
              </router-link>
            </template>
            <template v-for="notice in noticeList">
              <router-link :to="getNoticeUrl(notice.Type,notice.Id)" :key="notice.Id">
                <li>
                  <p class="title">{{notice.Title }}</p>
                  <!--<p class="content"><span v-html="HTMLDecode(notice.Title)"></span></p>-->
                </li>
              </router-link>
            </template>
          </ul>
        </div>
        <div class="removeHtmlDiv" style="display:none;"></div>
    </div>
    <div class="rank">
        <p class="title"><i class="fa fa-laba" style="color:red;font-size: 18px;"></i> 口碑排行榜</p>
        <div  ref="prolist" class="pro-list" :style="{width:koubeiItemWidth+'px'}">
          <div class="pro-list-group" :style="{height: proHeight+'px'}">           
              <div  class="list-item" :style="{height:itemHeight+'px',width:imgWidth+'px'}" v-for="recommendItem in recommendList" :key="recommendItem.ShopId">      
                <router-link :to="'/shangquan/pingjia?shopId='+recommendItem.ShopId">
                  <span class="tdnewImg" :style="{height:itemHeight+'px',width:imgWidth+'px'}">
                     <img :src="recommendItem.AdImage"  class="tdnew-pro-img" />
                  </span>   
                </router-link>
                <div class="logo" :style="{bottom:-logoBottom+'px'}">
                    <img :src="recommendItem.Logo" alt="">
                </div>
                <p class="storeName">{{recommendItem.ShopName}}</p>
                <div class="pinfen">
                    <i class="fa fa-star"></i><span>{{recommendItem.StarLevel}}</span>
                </div>
              </div>
          </div>
      </div>
    </div>
    <mu-list>
      <div class="proList" style="line-height: 40px;overflow: hidden;padding: 0 10px;">
        <mu-icon style="float: left;margin-top: 10px;" value=":fa fa-xingxing " color="red"/>
          <p style="line-height: 40px; float: left;font-weight: bold;font-size: 15px;margin-left: 5px;">店铺推荐</p>
      </div>
      <mu-list-item class="proList" v-for="storeItem in storeList" :key="storeItem.ShopId">
        <div class="product-item">
          <router-link :to="'/shangquan/pingjia?shopId='+storeItem.ShopId">
            <img :src="storeItem.Image" class="pro-img"> 
            
            <div class="product-info" :style="{ width:proItemInfoWidth+'px'}">
                <div style="overflow: auto;">
                  <p class="store_name">{{storeItem.CompanyName}} </p>
                  
                </div>
                <p class="fiveStar">
                  <mu-icon value=":fa fa-star"  slot="left" v-for="sIndex in storeItem.XingJi" :key="sIndex" />
                  <mu-icon value=":fa fa-star" class="empty_satr" slot="left" v-for="sIndex in (5-storeItem.XingJi)" :key="sIndex"/>
                  <span style="padding-left: 3%; color: rgb(244, 67, 54); font-size: 14px; width:15%;">{{storeItem.XingJi}}分</span>
                  <span class="distance">{{storeItem.Distance>1000? (storeItem.Distance/1000).toFixed(1)+'km':storeItem.Distance+'m'}}</span>
                </p>
              <div class="active" :style="{width:proItemInfoWidth+'px'}">
                <p class="fontIcon wua" v-html="GetIntroducedHtml(storeItem)"></p>
              </div> 
                <div class="saleinfo">  
                  <div class="saleCount">      
                    <p class="per_capita">人均<span style="font-size:12px;color:red; ">￥</span><span style="color:red; font-weight:bold;font-size:17px;">{{storeItem.AverageConsumption}}</span></p>  
                    <span style="float:right;color: #666;">已售{{storeItem.SaleCount}}</span>
                  </div>
                    <p class="price" v-if="storeItem.IsDiscount==1">{{storeItem.SaleDiscount}}折</p>
                    <p class="price" v-if="storeItem.IsDiscount==2">BAW</p>
                </div>
              </div>
            </router-link>
          </div>
      </mu-list-item>
    </mu-list>
    
    <mu-dialog :open="dialog" title="选择地区">
        需要知道您的位置才能提供更好的服务
        <mu-flat-button slot="actions" primary @click="selectArea" label="去选择"/>
        <mu-flat-button slot="actions" primary @click="close" label="暂不选择"/>
      </mu-dialog>
    <XR-bottom ref="XRbottom"></XR-bottom>
  </div>
</template>
<script>
import map from '../../util/map'
export default {
  data() {
    return {
      proItemInfoWidth: (parseInt(document.documentElement.clientWidth)-125),
      noticeMarginTop : 0,
      dialog: false,
      addressCache :'',
      animate: false,
      noticeList:[],
      noticeMarginTop : 0,
      koubeiItemWidth:0,
      
      imgWidth: (document.documentElement.clientWidth-36)/2,
      itemHeight: document.documentElement.clientWidth*0.92*0.48*0.7,
      logoBottom:document.documentElement.clientWidth*0.92*0.48*0.3*0.5,
      proHeight: document.documentElement.clientWidth*0.92*0.48-10,
      left:0,
      storeList:[],
      showCircle:true,
      navList:[],
      cityCode:'',
      recommendList :[],
      lng:window.localStorage.UserLocationLng,
      lat:window.localStorage.UserLocationLat
    }
  },
  mounted() {
    var countyCache = window.localStorage.ShopsPhysicalProductDetailDeliveryAreaCache
    if(countyCache){
      this.addressCache = countyCache
    }else{
      var cityCache = window.localStorage.ShopsPhysicalProductDetailDeliveryCityCache
      if(cityCache){
        this.addressCache = cityCache
      }
    }
    if(!this.addressCache){
      this.dialog = true    
    }else{
      if(this.addressCache.length>3){
        this.addressCache = this.addressCache.substr(0,3)+"..."
      }
      this.cityCode = window.localStorage.ShopsPhysicalProductDetailDeliveryCityCache
      this.initPage()    
    }
    
  },
  created: function () {   
    setInterval(this.calcNoticeMarginTop, 2000)
  },
  methods: {
    initPage(){
      this.getBannerList()
      this.getNavList()
      this.getRecommendList()
      this.calcNoticeMarginTop()
      this.getTopNoticeList()
      this.getStorePage()  
    },
    selectArea(){
      this.$router.push('/shangquan/address')
    },
    close(){
      var ths = this
      ths.dialog = false
      map.getLocation(function(){
        ths.addressCache = window.localStorage.ShopsPhysicalProductDetailDeliveryAreaCache
        ths.cityCode = window.localStorage.ShopsPhysicalProductDetailDeliveryCityCache
        ths.initPage()  
      })       
    },
    GetIntroducedHtml(storeItem){
      var introduced = storeItem.ShopIntroduced
      if(introduced){
        introduced = decodeURIComponent(introduced)
        return introduced.length>10?introduced.substr(0,10)+'...':introduced
      }
      return ''
    },
    GoHistory(){
      this.$router.goBack()
    },
    brandTransform(){
        if(this.recommendList.length>2 && this.recommendList.length%2==0){
            for(var i=0;i<2;i++){
              this.recommendList.push(this.recommendList[i])
              this.koubeiItemWidth =(this.imgWidth+12)*this.recommendList.length
            }   
          }
        this.timer()
        if(this.recommendList.length%2!=0){
            this.koubeiItemWidth =(this.imgWidth+12)*(this.recommendList.length+1)
        }
        else{
           this.koubeiItemWidth =(this.imgWidth+12)*this.recommendList.length
        }
    },
    timer(){    
       this.dom = this.$refs.prolist.style;
       setInterval(()=>{
        this.left -= (this.imgWidth+12)*2
        if(this.left == -this.koubeiItemWidth){
            this.left=0             
            this.setTransform(0)
            this.dom.transition= 'all 0s ease 0s'
            return      
          } 
        else{
            this.setTransform(this.left)
            this.dom.transition= 'all 500ms ease 0s'
        }  
        },3000)
    },
    setTransform(left){            
        this.dom.transform = `translate3d(${left}px,0px,0px)`
        this.dom['-webkit-transform'] = `translate3d(${left}px,0px,0px)`
        this.dom['-ms-transform'] = `translate3d(${left}px,0px,0px)`                   
      },
    getBannerList(){
        const ths = this;
        this.$post("/Shop/StoreServer/GetShopsPhysicalBannerList", {'areaId': this.cityCode, 'status':1})
        .then(function(res) {
          if (res.IsSuccess) {
            ths.loaded = false
            ths.$refs.swiper.setInterval(res.Data.Speed)
            ths.$refs.swiper.setBanners(res.Data.List)
          }
        })
        .catch(function(err) {
          console.log(err);
        });
      },
    getNavList(){
        const ths = this;
        this.$post("/Shop/StoreServer/GetShopsPhysicalNavList", {'areaId': this.cityCode})
        .then(function(res) {
          if (res.IsSuccess) {
            ths.loaded = false; 
            ths.navList = res.Data
          }
        })
        .catch(function(err) {
          console.log(err);
        });
      },
    getRecommendList(){
        const ths = this;
        this.$post("/Shop/StoreServer/GetShopsPhysicalRecommendList", {'CityId': this.cityCode, 'status':1})
        .then(function(res) {
          if (res.IsSuccess) {
            ths.loaded = false; 
            ths.recommendList = res.Data 
          }
          ths.brandTransform()
        })
        .catch(function(err) {
          console.log(err);
        });
      },
    getTopNoticeList(){
        const ths = this;
        this.$post("/Shop/ArticleServer/GetInformationPage", {'pageIndex':1, 'pageSize':2 , 'clientType' :2})
        .then(function(res) {
          if (res.IsSuccess) {
            ths.loaded = false; 
            ths.noticeList = res.Data.List
            ths.calcNoticeMarginTop()
          }
        })
        .catch(function(err) {
          console.log(err);
        });
      },
    getNoticeUrl(type,id){
      if(type == 1){
        return '/informationDetail?id='+id
      }else{
        return '/informationImgDetail?id='+id
      }
    },
    HTMLDecode(text) { 
      var temp = document.createElement("div"); 
      temp.innerHTML = text; 
      var output = temp.innerText || temp.textContent; 
      temp = null; 
      return output; 
    },
    touchEvent(){
      var scrollTop = this.$el.scrollTop
      var opacityValue=this.$el.scrollTop/250

      document.querySelector('.XR-search-head').style.background='rgba('+this.themeColor+','+opacityValue+')'
      if(scrollTop >=200 ){
        document.querySelector('.search-ctrl').style.background='rgba(255,255,255,0.3)'
      }
      else{
        document.querySelector('.search-ctrl').style.background='rgba('+this.themeColor+',0.3)'
      }
    },
    calcNoticeMarginTop(){
        var ths = this
        ths.animate = true
        setTimeout(()=>{
          ths.noticeList.push(ths.noticeList[0])
          if(ths.noticeList.length>2){
              ths.noticeList.shift()
          }
          ths.animate = false
      },500)
    },
    getStorePage(){
      const ths = this;
      this.$post("/Shop/StoreServer/GetShopsPhysicalStorePage", { 'areaId': this.cityCode, 'pageIndex':1, 'pageSize':10, 'longitude':this.lng, 'latitude':this.lat , 'sort':'distance'})
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false;      
          ths.storeList = res.Data.List
        }
      })
      .catch(function(err){
        console.log(err);
      });
    },
    goToStoreList(navItem){
      if(navItem.Ftype == 1){
        this.$router.push('/shangquan/temai?categoryId='+navItem.FcateId)
      }else{
        window.location.href = navItem.Flink
      }
    }
  }
};
</script>
<style>
.shangquanindexPage .XR-search-head{
  position: fixed;
  background: rgb(0,0,0,0);
  box-shadow: none;
  height: 56px;
  text-align: center;
}

.shangquanindexPage .XR-search-head .mu-appbar-title {
  font-size: 16px;

}
.shangquanindexPage .XR-search-head .title .mu-icon-button {
  position: absolute;
  left: 0;
  top: 0;
  color:white;
}
.shangquanindexPage .XR-search-head .title .title-text {
  margin: 0;
  line-height: 56px;
}


.shangquanindexPage .XR-search-head .search-ctrl{
  height: 32px;
  width: 100%;
  line-height: 32px;
  border-radius: 25px;
  color:#ccc;
  background: rgba(71,74,79,0.3);
  overflow: hidden;
  padding-right: 0;
}
.shangquanindexPage .XR-search-head .search-ctrl .input-ctrl{
  float: left;
  line-height: 32px;
  height: 32px;
  font-size: 12px;
  width: 80%;
  background: inherit;
  border: none;
  outline :none;
  text-align: left;
  color:#fff;
}
.shangquanindexPage .XR-search-head .search-ctrl .icon-ctrl{
  width: 10%;
  float: right;
  line-height: 28px;
  text-align: right;
  color:#ccc;
}
.shangquanindexPage .XR-search-head .right{
  border-radius: 50%;
  background: rgba(71,74,79,0.3);
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
}
.shangquanindexPage .XR-search-head .right .fa-fenlei1{
  color: #fff;
  margin-top: 2px;
  font-size: 22px;
}
.shangquanindexPage .XR-search-head-chip{
  height: 26px;
  margin-top: 3px;
  padding:0 12px 0 4px;
  border-radius: 0;
}
.shangquanindexPage .XR-search-head-chip .mu-chip-delete-icon{
  width: 16px;
  height: 16px;
}
.shangquanindexPage .mu-appbar-title .fa-xisearch{
    width: 20%;
    padding-left: 5%;
    line-height: 32px;
    float: left;
    font-size: 16px;
    color: #fff;
}
.shangquanindexPage .mu-appbar .left .mu-flat-button {
    height: 26px;
    font-size: 14px;
    background: rgba(71,74,79,0.3);
    box-shadow: none;
    min-width: 50px;
    padding-left: 10px;
    padding-right: 0;
}
.shangquanindexPage .mu-flat-button.label-before .mu-flat-button-label{
  padding-right: 0px;
  color: #fff;
  padding-left: 0px;
}
.shangquanindexPage .mu-flat-button.label-before .fa-angle-down{
  font-size: 14px;
  width: 20px;
  color: #fff;
}
.shangquanindexPage .bannerCom{
  width: 100%;
  position: relative;
  overflow: hidden;
}
 .shangquanindexPage .bannerCom .wh_content {
    height: 100%;
  }
  .shangquanindexPage .bannerCom .wh_swiper{
    height: 100%;
    position: relative;
  }
  .shangquanindexPage .bannerCom .circle{
    width: 120%;
    height:100px;
    position: absolute;
    z-index: 0;
    bottom: -40px;
    left: -10%;
    background: #fff;
    border-radius: 50%;
  }
.shangquanindexPage .nav {
  margin: 0px 0 6px;
}
.shangquanindexPage .nav ul {
  width: 100%;
  overflow: hidden;
  background: white;
  padding: 12px 0 12px;
}
.shangquanindexPage .nav li {
  float: left;
  width: 25%;
  background: white;
  padding: 3px 0;
  list-style: none;
  position: relative;
  text-align: center;
}
.shangquanindexPage .nav li img.new{
  position: absolute;
  right: 7px;
}
.shangquanindexPage .nav li .link-btn {
  display: block;
  overflow: hidden;
}
.shangquanindexPage .nav li .link-btn img {
  width: 60px;
  height: 60px;
  display: block;
  margin: 5% auto;
}
.shangquanindexPage .nav li .link-btn .fa{
  width: 35px;
  height: 35px;
  margin: 5% auto;
  line-height: 35px;
  font-size: 20px;
}
.shangquanindexPage .nav li .link-btn i.icon-jkklgo {
  color: #666;
  font-size: 2rem;
  line-height: 1.2;
  text-align: center;
  display: block;
}
.shangquanindexPage .nav li .link-btn b {
  text-align: center;
  font-size: 14px;
  background: #fff;
  color: #666;
  display: block;
  white-space: nowrap;
  font-weight: 400;
}

.shangquanindexPage #gonggao
{
    width:calc(100% - 20px);
    color:#000;
    padding:10px 0;
    background:white;
    position:relative;
    overflow:hidden;
    margin:6px 0;
    display: flex;
    align-items: center;
    background: url('/static/index/toutiaobg.png');
    background-size: 100% 100%;
}
.shangquanindexPage #gonggao .gg-title{ float:left; width:20%; padding:0 2%;}  
.shangquanindexPage #gonggao .gg-title img { height:35px;margin-top: 10px;margin-left: 10px; display:block;}
.shangquanindexPage #gonggao .gg-list {  width:72%; height:46px; overflow:hidden;  padding-left:3%;  }
.shangquanindexPage #gonggao .gg-list ul { height:92px; padding-left:0;}
.shangquanindexPage #gonggao .gg-list img { float:left; margin-top:15px;}
.shangquanindexPage #gonggao .gg-list li { height:22px; padding:3px 0; list-style:none;line-height:100%;}
.shangquanindexPage #gonggao .gg-list li p.title { height:16px; font-size:14px; color:#111; text-overflow:ellipsis; overflow:hidden;white-space:nowrap;}
.shangquanindexPage #gonggao .gg-list p.content { height:16px; line-height:16px; font-size:12px; text-overflow:ellipsis; overflow:hidden;white-space:nowrap;color: #000;}

.shangquanindexPage #gonggao .gg-list .fa-laba{color: red;margin-top:8px;font-size: 22px; }
.shangquanindexPage .show-right .mu-item-content{
    display: flex;
    width: 80%;
}
.shangquanindexPage .mu-list{
  background: #fff;
  padding: 0 0 76px;
}
.shangquanindexPage .mu-list .mu-item{
  padding: 0px;
}
.shangquanindexPage .mu-item.show-left{
  padding-left: 45px;
  
}
.shangquanindexPage .mu-list .proList{
  border-bottom: 1px solid #f5f5f5;
}
.shangquanindexPage .mu-list .proList:last-child{
  border: none;
}
.shangquanindexPage .mu-list .proList2{
  border: 0;
}
.shangquanindexPage .mu-list .fa-xingxing{
  font-size: 20px;
}
.shangquanindexPage .proList .demo-flat-button .mu-flat-button-wrapper .mu-flat-button-label{
  font-size: 14px;
  padding: 0px;
}
.shangquanindexPage .proList .demo-flat-button .mu-flat-button-wrapper .fa-angle-right{
  font-size: 16px;
  color: #ccc;
}
.shangquanindexPage .proList .demo-flat-button .mu-flat-button-wrapper{
  padding-right: 16px;
}


.shangquanindexPage .product-list{
  overflow: hidden;
  margin-top: 5px;
  border-bottom:1px solid #eee;
  background: white;
}
.shangquanindexPage .product-item{
  width:100%;
  overflow: hidden;
  padding: 10px;
}
.shangquanindexPage .product-item ~ .product-item{
  border-top:1px solid #eee;
}
.shangquanindexPage .product-item a{  
  color:black;
}
.shangquanindexPage .product-item .pro-img{
  width: 95px;
  float: left;
  background: white;
  height: 95px;
  object-fit: cover;
}
.shangquanindexPage .product-item .product-info{
  float: left;
  padding: 1px;
  margin-left: 10px;
  word-break: break-all;
}
.shangquanindexPage .product-item  .product-info .product-name{
  overflow:hidden;
  line-height: 16px;
  height: 16px;
  font-size: 14px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.shangquanindexPage .product-item .product-info .active{
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.shangquanindexPage .product-item  .product-info .active .fontIcon{
  float: left;
  font-size: 12px;
  color:#666;
  border-radius: 2px;
  line-height: 14px;
  margin: 6px 1px;
}
.shangquanindexPage .product-item  .saleinfo{
  overflow: hidden;
  line-height: 16px;
  font-size: 12px;
}
.shangquanindexPage .product-item  .product-info .price{
  font-size: 12px;
  width: 40px;
  color:Red;
  text-align: center;
  border: 1px solid #f5c3c3;
  border-radius: 1px;
  margin-top: 3px;
}
.shangquanindexPage .product-item  .product-info .saleinfo .price .fa{
  font-size: 14px;
  margin-right: 5px;
}
.shangquanindexPage .product-item  .product-info .saleinfo .saleCount{
  color: rgb(170, 170, 170);
  text-align: right;
  margin: 5px 0;
  overflow: auto;
}
.shangquanindexPage .product-item  .product-info .saleinfo .saleCount .per_capita{
  width: 60%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  text-align: left;
  float: left;
}
.shangquanindexPage .shop-list .shop-item .shop-product-list{
  overflow: hidden;
}
.shangquanindexPage .shop-list .shop-item .shop-product-list .shop-product-item{
  width:33.33%;
  float: left;
}
.shangquanindexPage .shop-list .shop-item .shop-product-list .shop-product-item .pro-img{
  width: 100%;
}

.shangquanindexPage .shop-list .entrance{
  margin-top: 5%;
  height: 100px;
  padding: 0 3%;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #dedede;
}
.shangquanindexPage .shop-list .enceimg{
  float: left;
  width: 20%;
  height: 100%;
   display: flex;
  align-items: center;  
  justify-content: center;
}
.shangquanindexPage .shop-list .enceimg img{
  width: 100%;
}
.shangquanindexPage .shop-list .store{
  width: 60%;
  height: 100%;
  padding: 3% 1%;
  float: left;
}
.shangquanindexPage .shop-list .jian{
  width: 20%;
  height: 100%;
  text-align: center;
  padding: 5% 0;
  float: left;
}
.shangquanindexPage .shop-list .jian img{
  width: 15px;
  height: 10px;

}
.shangquanindexPage .shop-list .pro-list{
  overflow: hidden;
  width: 100%; 
  padding: 3% 3% 0 3%;
  background: #fff;
}
.shangquanindexPage .shop-list .pro-list .item-left{
  float: left;
  width: 32%;
  text-align: center;
  background-size: cover;
  position: relative;
}
.shangquanindexPage .shop-list .pro-list .item-left img{
  width: 90%;
}
.shangquanindexPage .shop-list .pro-list .item-left span{
  background: #f19500;
  color: white;
  padding:  0 2%;
  font-size: 14px;
  font-weight: bold;
  position: absolute;
  bottom: 3px;
  left: 30px;
}
.shangquanindexPage .proList .mu-item-title{
  font-size: 15px;
  font-weight: bold;
}
.shangquanindexPage .rank{
  background: #fff;
  margin: 6px 0;
  width: 100%;
  overflow: hidden;
}
.shangquanindexPage .rank .pro-list .pro-list-group{
  width: 100%;
  margin-top: 10px;
}
.shangquanindexPage .rank p.title{
    padding: 14px 4%;
    font-size: 15px;
    border-bottom: 1px solid #f5f5f5;
    font-weight: bold;
}
.shangquanindexPage .rank .pro-list .pro-list-group .list-item{
  width: 48%;
  float: left;
   position: relative;
   margin-left: 12px;
}
.shangquanindexPage .rank .pro-list .pro-list-group .pinfen{
  font-size: 16px;
  position: absolute;
  right: 0;
  color: #fff;
  background: rgba(0, 0, 0, 0.3);
  top: 40%;
  padding: 3px 5px;
}
.shangquanindexPage .rank .pro-list .pro-list-group .pinfen .fa-star{
  color: orange;
  padding-right: 5px
}
.shangquanindexPage .rank .pro-list .pro-list-group .list-item .tdnewImg{
  display: inline-block;
  text-align: center;
  overflow: hidden;
}
.shangquanindexPage .rank .pro-list .pro-list-group .list-item .tdnew-pro-img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.shangquanindexPage .rank .pro-list .pro-list-group .list-item .logo{
  width: 45px;
  height: 45px;
  position: absolute;
  left: 5%;
}
.shangquanindexPage .rank .pro-list .pro-list-group .list-item .logo img{
  width:100%;
  height: 100%;
  display: block;
}
.shangquanindexPage .rank .pro-list .pro-list-group .list-item .storeName{
  width: 50%;
  font-weight: bold;
  position: absolute;
  left: 38%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

}
.shangquanindexPage .proList .fiveStar{
  line-height: 30px;
  height: 30px;
  align-items: center;
  display: flex;
}
.shangquanindexPage .proList .fiveStar .fa-star{
  font-size: 12px;
  width: 12px;
  height: 12px;
  color: orange;
}
.shangquanindexPage .proList .fiveStar .empty_satr{
  font-size: 12px;
  width: 12px;
  height: 12px;
  color: #ccc;
}
.shangquanindexPage  .distance{
    color: #666;
    text-align: right;
    float: right;
}
.shangquanindexPage .store_name{
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: -webkit-box;
}

.shangquanindexPage .marquee_top {
	transition: all 1s;
	margin-top: -50px
}
</style>



// WEBPACK FOOTER //
// src/pages/shangquan/sqindex.vue